import React, { useState } from "react";
import { Col, Row, UiButton, UiDivider, UiTabPanel, UiText, useBreakpointValue } from "~/components/elements";
import { AvailableStyles } from "~/pages/result-detail/AvailableStyles";
import { ArrowRightIcon } from "~/components/icons/SvgIcons";
import UpgradePlanModal from "~/components/modals/UpgradePlanModal";
import { useAppSelector } from "~/hooks";

export const AllAccessTabPanel: React.FC<{ jobId: string }> = ({ jobId }) => {
  const jobItemData = useAppSelector(state => state.dashboard.jobItemData);
  const vrTitle = useBreakpointValue<any>({ base: "headline4", sm: "headline2" });
  const vrBody1 = useBreakpointValue<any>({ base: "body2", sm: "body1" });
  const vrBody2 = useBreakpointValue<any>({ base: "body3", sm: "body2" });
  const [showUpgradePlanModal, setShowUpgradePlanModal] = useState(false);

  return (
    <UiTabPanel>
      <UpgradePlanModal
        upgradeType="all_access"
        visible={showUpgradePlanModal}
        data={{ jobId }}
        onClose={() => setShowUpgradePlanModal(false)}
      />
      <Col mt={1} pos="relative">
        <Col align="center">
          <UiText textAlign="center" vr={vrTitle}>
            Get more styles, pay way less
          </UiText>
          <UiText textAlign="center" vr={vrBody1} mt={3}>
            Access 35+ exclusive styles with an all-access plan
          </UiText>

          <Col mt={5}>
            <UiText textAlign="center" vr={vrBody2}>
              Create up to 15 new photos every week.
            </UiText>
          </Col>
        </Col>
        <UiDivider text="Available styles" containerProps={{ my: 4, w: "full" }} />
        <AvailableStyles type="all_access" photoshootType={jobItemData?.type || "one_person"} groupByOutfit />

        <Row
          mx={{ base: 4, sm: "auto" }}
          gap={2}
          align="center"
          justifyContent="space-between"
          pos={{ base: "fixed", md: "absolute" }}
          bottom="3rem"
          left={0}
          right={0}
          bg="white"
          zIndex="2"
          borderRadius="2.5rem"
          maxW="29rem"
          p={3}
        >
          <Row align="center">
            <UiText vr="body2" color="neutral.gray600" textAlign="center">
              Upgrade account to an All Access Plan
            </UiText>
          </Row>
          <UiButton
            size="sm"
            variant="outline"
            borderColor="navy"
            bg="#353FB5"
            color="navy"
            _hover={{ bg: "navy", color: "navy" }}
            onClick={() => {
              setShowUpgradePlanModal(true);
            }}
          >
            <Row align="center" mx={3}>
              <UiText vr="title1" color="white">
                Upgrade now
              </UiText>
              <ArrowRightIcon boxSize={5} dColor="white" />
            </Row>
          </UiButton>
        </Row>
      </Col>
    </UiTabPanel>
  );
};
